module.exports = __webpack_public_path__ + "static/media/notification.ec5aa5b.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/notification.wav
// module id = LdL2
// module chunks = 1